module.exports = __webpack_public_path__ + "media/images/location-6403d624bad35f2e460ac29332285dab.svg";